import React, { useState } from 'react'
import './style.css'

export default function Paragraphs({element, line, letter, onChange}) {
  const [open, setOpen] = useState(false)

  return (
    <div tabIndex={0} onBlur={(e) => {
      if (e.currentTarget.contains(e.relatedTarget)) {
        return
      }
      setOpen(false)
    }}>
        <div className='Position' onClick={()=>setOpen(true)}>{element}
            <div className={open ? 'Position_Con Position_Con_Open' : 'Position_Con'}>
                <div className='Position_Con1'>
                  <div className='Position_Input_Con'>
                    <p>Line Spacing</p>
                    <input step={0.5} type='number' value={line || 0} onChange={(e)=>onChange("lineHeight", e?.target?.value * 1)}/>
                  </div>
                  <div className='Position_Input_Con'>
                    <p>Letter Spacing</p>
                    <input step={0.5} type='number' value={letter || 0} onChange={(e)=>onChange("letterSpacing", e?.target?.value * 1)}/>
                  </div>
                </div>
            </div>
        </div>
    </div>
  )
}
